export default {
  ZH_HK: {
    settings_item_line1: "用戶設置",
    settings_item_line2: "系統默認語言",
    settings_item_line3: "遊戲間隔題數",
    settings_item_line4: "開始遊戲時長",
    settings_item_line5: "遊戲勝利標準",
    input: "填入數字1~100",
    required: "此項不能為空",
    min_max: "最小值為1且最大值為100",
    saved: "更改已儲存",
    invalidFile: "不支持的圖片",
    invalidNumber: "不是有效數字",
    minNumber: "最小值是1",
    maxNumber: "最大值是100",
    featureNotYet: "功能暫未開放"
  },
  zh_cn: {
    settings_item_line1: "用户设置",
    settings_item_line2: "系统默认语言",
    settings_item_line3: "游戏间隔题数",
    settings_item_line4: "开始游戏时长",
    settings_item_line5: "游戏胜利标准",
    input: "填入数字1~100",
    required: "此项不能为空",
    min_max: "最小值为1且最大值为100",
    saved: "更改已保存",
    invalidFile: "不支持的图片",
    invalidNumber: "不是有效数字",
    minNumber: "最小值是1",
    maxNumber: "最大值是100",
    featureNotYet: "功能暂未开放"
  },

  EN: {
    settings_item_line1: "User Settings",
    settings_item_line2: "System default language",
    settings_item_line3: "Game interval number",
    settings_item_line4: "Start game time",
    settings_item_line5: "Game victory criteria",
    input: "Fill in the numbers 1 to 100",
    required: "This item cannot be empty",
    min_max: "The minimum value is 1 and the maximum value is 100",
    saved: "Changes saved",
    invalidFile: "Invalid file",
    invalidNumber: "Invalid number",
    minNumber: "Minimum number is 1",
    maxNumber: "Maximum number is 100",
    featureNotYet: "This feature is not yet available"
  },
  es: {
    settings_item_line1: "Configuración de usuario",
    settings_item_line2: "Idioma predeterminado del sistema",
    settings_item_line3: "Número de preguntas entre juegos",
    settings_item_line4: "Duración inicial del juego",
    settings_item_line5: "Criterios de victoria del juego",
    input: "Ingrese un número del 1 al 100",
    required: "Este campo no puede estar vacío",
    min_max: "El valor mínimo es 1 y el máximo es 100",
    saved: "Cambios guardados",
    invalidFile: "Archivo no admitido",
    invalidNumber: "Número no válido",
    minNumber: "El número mínimo es 1",
    maxNumber: "El número máximo es 100",
    featureNotYet: "Esta función aún no está disponible"
  }
};
